// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VCurrencyField from 'v-currency-field';

import vuetify from './plugins/vuetify';
import App from './App';
import router from './router';
import i18n from './i18n';
import store from './store';
import api from './utils/api';
import filters from './utils/filters';
import Confirm from './components/Confirm';

// Globals
global.store = store;
global.api = api();

Vue.config.productionTip = false;

// Filters
Object.keys(filters).forEach((filter) => {
  Vue.filter(filter, filters[filter]);
});

// Use
Vue.use(VCurrencyField, {
  locale: 'es-ES',
  decimalLength: 2,
  autoDecimalMode: false,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: true,
  allowNegative: true,
});

// Components
Vue.component('confirm', Confirm);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  i18n,
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js